import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/',
    component: () => import( '../views/homePage.vue')
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import( '../views/homePage.vue')
  },
  {
    path: '/partners',
    name: 'partners',
    component: () => import( '../views/partners.vue')
  },
  {
    path: '/buttom',
    name: 'buttom',
    component: () => import( '../components/buttom.vue')
  },
  {
    path: '/custommall',
    name: 'custommall',
    component: () => import( '../views/custommall.vue')
  },
  {
    path: '/flowPath',
    name: 'flowPath',
    component: () => import( '../views/flowPath.vue')
  },
  {
    path: '/hotel',
    name: 'hotel',
    component: () => import( '../views/hotel.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import( '../views/news.vue')
  },
  {
    path: '/companynews',
    name: 'companynews',
    component: () => import( '../views/companynews.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import( '../views/about.vue')
  },
  {
    path: '/qualifications',
    name: 'qualifications',
    component: () => import( '../views/qualifications.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import( '../views/contact.vue')
  },
  {
    path: '/newsDetail',
    name: 'contnewsDetailact',
    component: () => import( '../views/newsDetail.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
